import React from 'react'

import { ToggleSwitchProps } from './interface'

export function withToggleSwitch(Component: React.FC<ToggleSwitchProps>) {
  function WithToggleSwitch(props: ToggleSwitchProps) {
    return <Component {...props} />
  }

  return WithToggleSwitch
}
